import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { SALES_PRODUCTS_CONFIGURATION } from '../interfaces/environment.interfaces';
import { ApiSalesProductsResponse, SalesProducts } from '../state/sales-products/sales-products.model';

@Injectable({ providedIn: 'root' })
export class SalesProductsService {
  private config = inject(SALES_PRODUCTS_CONFIGURATION);
  private http = inject(HttpClient);

  requestSalesProducts(): Observable<SalesProducts> {
    return this.http
      .get<ApiSalesProductsResponse>(`${this.config.leadServiceUrl}/sales-products`)
      .pipe(map(this.mapSalesProductsToFrontend));
  }

  private mapSalesProductsToFrontend(apiSalesProducts: ApiSalesProductsResponse): SalesProducts {
    return {
      hasApiToken: apiSalesProducts.api_token,
      hasScanUserAccess: apiSalesProducts.scan_access,
    };
  }
}
